import { Component, Input } from '@angular/core';
import { InstructorCard } from '../../../core/domain/instructor-card';


@Component({
  selector: 'app-instructor-card',
  templateUrl: './instructor-card.component.html',
  styleUrls: ['./instructor-card.component.css'],
  imports: [],
})
export class InstructorCardComponent {
  @Input() instructorCard?: InstructorCard;
}
